import {
  isInfoOverlayComposite,
  type CompositeComponentDto,
} from '@/state/queries/composite-components/use-get-composite-components';

/** Whether a composite may appear in session-type virtual defaults for the given session type. */
export function compositeMatchesSessionTypePolicy(
  composite: Pick<CompositeComponentDto, 'allowedIn' | 'applicability' | 'role'>,
  sessionType: string,
): boolean {
  if (isInfoOverlayComposite(composite)) {
    return false;
  }
  const applicability = composite.applicability;
  if (Array.isArray(composite.allowedIn) && composite.allowedIn.length === 0) {
    if (applicability !== undefined && applicability !== null) {
      return false;
    }
  }

  const allowedInSession = composite.allowedIn?.includes('session') ?? false;
  const sessionTypes = applicability?.sessionTypes;
  const matchesSpecificType = sessionTypes?.includes(sessionType) ?? false;

  if (matchesSpecificType) {
    return true;
  }

  if (!allowedInSession) {
    return false;
  }

  if (applicability?.flowScopes?.length) {
    return false;
  }

  return !sessionTypes?.length;
}
